"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TomatoCard = exports.GridMoreBaseBox = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Card_1 = require("./Card");
var utils_1 = require("../utils");
exports.GridMoreBaseBox = styled_components_1.default.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: inherit;\n\tmargin: 0 auto;\n\tdisplay: grid;\n\twidth: 1190px;\n\t", "\n"], ["\n\twidth: inherit;\n\tmargin: 0 auto;\n\tdisplay: grid;\n\twidth: 1190px;\n\t",
    "\n"])), function (props) {
    var _a = props.gridCol, gridCol = _a === void 0 ? 5 : _a, _b = props.gridGap, gridGap = _b === void 0 ? utils_1.MINI_UI_GAP : _b;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\tgrid-gap: ", "px;\n\t\t\tgrid-template-columns: repeat(", ", 1fr);\n\t\t"], ["\n\t\t\tgrid-gap: ", "px;\n\t\t\tgrid-template-columns: repeat(", ", 1fr);\n\t\t"])), gridGap, gridCol);
});
exports.TomatoCard = function (props) {
    var products = props.products, customUI = props.customUI, prm = props.prm, spm = props.spm, col = props.col, placeholderBg = props.placeholderBg;
    if (!products) {
        return null;
    }
    return (React.createElement(exports.GridMoreBaseBox, { gridCol: col, gridGap: utils_1.MINI_UI_GAP }, products.map(function (ele, index) {
        return (React.createElement(Card_1.TomatoCardItem, __assign({ key: (ele === null || ele === void 0 ? void 0 : ele.gpid) + "_" + index, customUI: customUI, product: ele, prm: __assign(__assign({}, prm), { position: index }), spm: spm, placeholderBg: placeholderBg }, utils_1.getTomatoWidth(col, customUI))));
    })));
};
var templateObject_1, templateObject_2;
